import { getByPath } from "./ruleEngine";

const resolveDerived = (dependency, stores) => {
  const source = getByPath(stores, `${dependency.from.store}.${dependency.from.path}`);
  if (!Array.isArray(source)) return [];

  const mapped = source
    .map((item) => {
      if (typeof item !== "object" || item == null) return item;
      return getByPath(item, dependency.map);
    })
    .filter((v) => v != null && v !== "");

  return dependency.distinct ? [...new Set(mapped)] : mapped;
};

const resolveRef = (dependency, stores) =>
  getByPath(stores, `${dependency.store}.${dependency.path}`);

export const resolveDependency = (dependencyId, config, stores) => {
  const dependency = (config.dependencies || []).find((d) => d.id === dependencyId);
  if (!dependency) return undefined;

  switch (dependency.type) {
    case "derived":
      return resolveDerived(dependency, stores);
    case "ref":
      return resolveRef(dependency, stores);
    default:
      return undefined;
  }
};

export const resolveSectionDependencies = (sectionConfig, config, stores) => {
  const refs = sectionConfig?.dependencyRefs || [];
  return refs.reduce((acc, refId) => {
    acc[refId] = resolveDependency(refId, config, stores);
    return acc;
  }, {});
};
